import { render, staticRenderFns } from "./JobsDetails.vue?vue&type=template&id=9b0ace1a&lang=pug"
import script from "./JobsDetails.vue?vue&type=script&lang=js"
export * from "./JobsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports